import axios from 'axios'
import { API_BASE_URL } from '../globalVar'

let baseUrl = API_BASE_URL
//let baseUrl = process.env.VUE_APP_API_BASE_URL

export const pipelineApiService = {
    getResellerPipelines,
    getPipelineRules,
    getRuleParameters,
    getRuleComponents,
    addPipeline,
    addPipelineRule,
    addResellerPipeline,
    addRuleParameter,
    updateRuleParameter,
    addRuleComponent,
    getPipelines,
    getPipelineTypes
}

function getResellerPipelines(payload) {
    return axios.post(baseUrl + '/api/admin/v1/pipeline/getall', payload)
}

function getPipelineRules(payload) {
    return axios.post(baseUrl + '/api/admin/v1/pipeline/getpiplinerules', payload)
}

function getRuleParameters(payload) {
    return axios.post(baseUrl + '/api/admin/v1/pipeline/getruleparameters', payload)
}

function getRuleComponents() {
    return axios.get(baseUrl + '/api/admin/v1/pipeline/getrulecomponents')
}

function addPipeline(payload) {
    return axios.post(baseUrl + '/api/admin/v1/pipeline/addpipeline', payload)
}

function addPipelineRule(payload) {
    return axios.post(baseUrl + '/api/admin/v1/pipeline/addpipelinerule', payload)
}

function addRuleComponent(payload) {
    return axios.post(baseUrl + '/api/admin/v1/pipeline/addrulecomp', payload)
}

function addResellerPipeline(payload) {
    return axios.post(baseUrl + '/api/admin/v1/pipeline/addresellerpipeline', payload)
}

function addRuleParameter(payload) {
    return axios.post(baseUrl + '/api/admin/v1/pipeline/addruleparam', payload)
}

function updateRuleParameter(payload) {
    return axios.post(baseUrl + '/api/admin/v1/pipeline/updateruleparam', payload)
}

function getPipelines() {
    return axios.get(baseUrl + '/api/admin/v1/pipeline/getpipelines')
}

function getPipelineTypes() {
    return axios.get(baseUrl + '/api/admin/v1/pipeline/getpiplinetypes')
}